import { preloadImage } from 'utils'
import { drawToCanvas } from '.'
import { MediaFrame } from '../../../types'

export async function getImageFrames(source: File | string): Promise<MediaFrame[]> {
    const url = typeof source === 'string' ? source : URL.createObjectURL(source)
    const img = await preloadImage(url)
    const canvas = drawToCanvas(img, img.naturalWidth, img.naturalHeight)

    if (typeof source !== 'string') {
        URL.revokeObjectURL(url)
    }

    return [{ canvas, delay: 0 }]
}
